export const SidePanelsIcon = (props: Record<string, unknown>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-side-panels-icon"
    {...props}
    >
    {/* dashed square border */}
    <path d="M14 21h1" />
    <path d="M14 3h1" />
    <path d="M9 21h1" />
    <path d="M9 3h1" />
    <path d="M19 21a2 2 0 0 0 2-2" />
    <path d="M5 21a2 2 0 0 1-2-2" />
    <path d="M19 3a2 2 0 0 1 2 2" />
    <path d="M5 3a2 2 0 0 0-2 2" />

    {/* left solid line */}
    <path d="M3 5v14" strokeWidth="4" />

    {/* right solid line */}
    <path d="M21 5v14" strokeWidth="4" />

    {/* left-right arrows */}
    <path d="m8 16 -4-4 4-4" />
    <path d="M4 12h16" />
    <path d="m16 8 4 4-4 4" />
  </svg>
);
